module.exports = __webpack_public_path__ + "static/media/phd_gatenga4.c2db0300.jpg";